import { Center, Skeleton, Stack } from "@mantine/core"
import type React from "react"

const OfferSkeleton: React.FC = () => (
  <Center p="xl">
    <Stack gap="md" w={300}>
      <Stack align="center">
        <Skeleton circle h={64} w={64} />
        <Skeleton height={24} width="75%" />
        <Skeleton height={20} width="50%" />
      </Stack>

      <Stack gap="xs">
        <Skeleton height={32} />
        <Skeleton height={20} width="85%" />
        <Skeleton height={20} width="70%" />
        <Skeleton height={20} width="80%" />
      </Stack>

      <Stack gap="xs">
        <Skeleton height={16} width="30%" />
        <Skeleton height={24} />
        <Skeleton height={16} width="30%" />
        <Skeleton height={24} />
      </Stack>

      <Center>
        <Skeleton height={40} width="30%" />
      </Center>
    </Stack>
  </Center>
)

export default OfferSkeleton
